import { render, staticRenderFns } from "./VideoOptionsDropdown.vue?vue&type=template&id=98521056&scoped=true&"
import script from "./VideoOptionsDropdown.vue?vue&type=script&lang=js&"
export * from "./VideoOptionsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./VideoOptionsDropdown.vue?vue&type=style&index=0&id=98521056&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98521056",
  null
  
)

export default component.exports